import React from 'react';

import Tooltip from 'components/common/Tooltip';
import EcoIcon from 'images/zappos/eco-icon.svg';

import css from 'styles/components/account/returns/returnPackagelessTooltip.scss';

const packagelessTooltipContent = (
  <>
    <h2 className={css.tooltipTitle}>Most Sustainable</h2>
    <p>Reduced packaging and more items in shipments helps us reduce trucks on the road!</p>
  </>
);

const ReturnPackagelessTooltip = () => (
  <Tooltip
    tooltipId="returnPackagelessTootip"
    wrapperClassName={css.tooltipWrapper}
    mobileWrapper={css.mobileContainer}
    direction="top"
    content={packagelessTooltipContent}
  >
    <img className={css.ecoIcon} src={EcoIcon} alt="eco" />
  </Tooltip>
);

export default ReturnPackagelessTooltip;
